import { render, staticRenderFns } from "./fb_card_item.vue?vue&type=template&id=6421c58f&scoped=true"
import script from "./fb_card_item.vue?vue&type=script&lang=js"
export * from "./fb_card_item.vue?vue&type=script&lang=js"
import style0 from "./fb_card_item.vue?vue&type=style&index=0&id=6421c58f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6421c58f",
  null
  
)

export default component.exports